<template>
	<div class="exclusivePrice-body">
		<div class="fx-header">
			<p>商品专有价格</p>
		</div>
		<div class='container'>
			<div class="left-box">
				<div class="btn-box">
					<div class="btn" :class="isActive === 'isCategory' ? 'active-btn' : ''" @click="typeChange('isCategory')">客户类别</div>
					<div class="btn" :class="isActive === 'isLevel' ? 'active-btn' : ''" @click="typeChange('isLevel')">客户等级</div>
				</div>
				<div class="search-box">
					<el-input
						class="search-input"
						v-model="name"
						placeholder="请输入关键词"
						size="small"
						@keyup.enter.native="treeReload">
						<el-button slot="append" icon="el-icon-search" @click="treeReload"></el-button>
					</el-input>
				</div>
				<div class="tree-box" style="flex: 1;overflow:auto">
					<el-tree ref="tree" node-key="id" accordion :data="treeData" :default-expanded-keys="expandedKey" :highlight-current='true' class="tree" :props="defaultProps" @node-click="handleNodeClick">
					</el-tree>
				</div>
			</div>
			<div class="right-box">
				<tableBox ref="tableBox"></tableBox>
			</div>
		</div>
	</div>
</template>
<script>
import tableBox from '@/components/exclusivePrice/tableBox.vue'
export default {
	name: 'exclusivePrice',
	components: {
		tableBox
	},
	data () {
		return {
			expandedKey: [],
			isActive: 'isCategory',
			name: '',
			treeData: [],
			defaultProps: {
				children: 'cus',
				label: 'name'
			},
			cusId: '',
			cusLevelId: '',
			cusCategoryId: '',
			cusName: '',
			matchbillcenterflag: 0,
			matchbillcenterpriceflag: 0,
			matchFlag: null
		}
	},
	created () {
		this.checkSmallCategory()
	},
	methods: {
		// 是否对接中台
		checkSmallCategory () {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
				}).then(res => {
					this.matchFlag = (res.matchbillcenterpriceflag === 1 && res.matchbillcenterflag === 1)
					this.treeReload()
				})
			})
		},
		handleNodeClick (data) {
			if (data.id === '-1') {
				this.cusId = ''
				this.cusLevelId = ''
				this.cusCategoryId = ''
				this.cusName = ''
				if (!this.matchFlag) {
					this.selectId = '-1'
					this.tableBoxReload()
					this.$nextTick(function () {
						this.$refs.tree.setCurrentKey('-1')
					})
				} else {
					this.$nextTick(function () {
						this.$refs.tree.setCurrentKey(this.selectId)
					})
				}
			} else if (data.cus) {
				this.cusId = ''
				this.cusName = ''
				let id = data.id
				if (this.isActive === 'isCategory') {
					this.cusLevelId = ''
					this.cusCategoryId = id
				} else {
					this.cusLevelId = id
					this.cusCategoryId = ''
				}
				if (!this.matchFlag) {
					this.selectId = id
					this.tableBoxReload()
					this.$nextTick(function () {
						this.$refs.tree.setCurrentKey(id)
					})
				} else {
					this.$nextTick(function () {
						this.$refs.tree.setCurrentKey(this.selectId)
					})
				}
			} else {
				this.cusId = data.id
				this.cusLevelId = ''
				this.cusCategoryId = ''
				this.cusName = data.name
				this.tableBoxReload(true)
				this.selectId = data.id
				this.$nextTick(function () {
					this.$refs.tree.setCurrentKey(data.id)
				})
			}
		},
		tableBoxReload (flag) {
			let params = {
				cusId: this.cusId,
				cusLevelId: this.cusLevelId,
				cusCategoryId: this.cusCategoryId,
				cusName: this.cusName,
				keyword: this.name
			}
			this.$refs.tableBox.changeData(params, flag)
		},
		init (flag, id) {
			if (this.matchFlag) {
				this.cusLevelId = ''
				this.cusCategoryId = ''
				let id = ''
				if (this.treeData.length > 0) {
					id = this.treeData[0].cus[0].cus[0].id
				}
				this.cusId = id
				this.$nextTick(function () {
					this.$refs.tree.setCurrentKey(id)
				})
				this.selectId = id
			} else {
				this.cusId = ''
				this.cusLevelId = ''
				this.cusCategoryId = ''
				this.$nextTick(function () {
					this.$refs.tree.setCurrentKey('-1')
				})
				this.selectId = '-1'
			}
			if (flag && id) {
				this.expandedKey = ['-1', id]
			} else {
				this.expandedKey = ['-1']
			}
			this.tableBoxReload()
		},
		treeReload () {
			let data = {
				name: this.name,
				type: this.isActive === 'isCategory' ? 0 : 1
			}
			this.$store.dispatch('requestFilePost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/customer/getCategoryORLevel4Price`,
				data: data
			}).then(res => {
				if (res.result) {
					if (res.data.length > 0) {
						let arr = [{
							name: '全部',
							id: '-1',
							cus: res.data
						}]
						this.treeData = arr
					} else {
						this.treeData = []
					}
					let flag = this.name !== ''
					let id = res.data[0] ? res.data[0].id : null
					this.init(flag, id)
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		typeChange (data) {
			this.isActive = data
			this.treeReload()
		}
	}
}
</script>
<style lang="stylus" scoped>
.exclusivePrice-body{
	font-family: Microsoft YaHei;
	flex: 1
	display flex
	flex-direction column
	.container{
		display: flex;
		flex: 1;
		overflow: hidden;
		padding: 20px 0 10px 0
	}
	.left-box{
		width: 220px;
		height: 100%;
		display: flex;
		flex-direction: column
	}
	.btn-box{
		width: 210px;
		height: 34px;
		border-radius: 17px;
		background-color: #F4F6F8
		display: flex
	}
	.btn{
		width: 105px;
		height: 100%;
		border-radius: 17px;
		background-color: #F4F6F8;
		display: flex;
		align-items: center;
		color: #595959;
		justify-content: center;
		cursor: pointer;
	}
	.search-box{
		margin: 10px 0;
		border-radius: 4px;
	}
	.active-btn{
		background-color: var(--fx-primary-color);
		color: #ffffff
	}
	.right-box{
		flex: 1;
		display: flex;
		overflow: hidden;
		margin-left: 20px
	}
}
</style>
<style lang="stylus">
.exclusivePrice-body {
	.is-current> .el-tree-node__content{
		background-color: #EDF6FF;
		color: var(--fx-primary-color);
	}
	.el-tree {
		overflow: auto;
		>.el-tree-node {
            min-width: 100%;
			display: block !important;
			float: left;
        }
    }
    .dialog-footer{
		text-align: center
	}
	.dialog-title {
		text-align: left
		.el-dialog__title {
			padding-left 10px
			border-left 5px solid var(--fx-primary-color)
		}
        .name-input{
            width :150px
        }
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
</style>
